import React from 'react';
import {Container, Row, Col} from 'react-bootstrap';

const Footer = () => {
  return (
    <>
        <div className='footer'>
            <Container>
                <Row>
                    <Col md={4}>
                        <div className='footer-col'>
                            <h5>Shortcuts</h5>
                            <ul>
                                <li><a href='#'>Home</a></li>
                                <li><a href='#'>Document Types</a></li>
                                <li><a href='#'>Languages</a></li>
                                <li><a href='#'>Testimonials</a></li>
                                <li><a href='#'>Pricing</a></li>
                                <li><a href='#'>Contact</a></li>
                            </ul>
                        </div>
                    </Col>
                    <Col md={4}>
                        <div className='footer-col'>
                            <h5>Social</h5>
                            <ul>
                                <li><a href='#'>Facebook</a></li>
                                <li><a href='#'>Instagram</a></li>
                                <li><a href='#'>Linkedin</a></li>
                                <li><a href='#'>Twitter</a></li>
                                <li><a href='#'>Website</a></li>
                            </ul>
                        </div>
                    </Col>

                    <Col md={4}>
                        <div className='footer-col'>
                            <h5>Address</h5>
                            <p>
                                <b>Zeeepy</b><br/>
                                7 Temasek Boulevard #12-07 Suntec Tower One Singapore 038987
                            </p>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    </>
  )
}

export default Footer